import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=64cb6fdd&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=64cb6fdd&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb6fdd",
  null
  
)

export default component.exports